import { NextPage } from 'next';
import { GetServerSideProps } from 'next';
import AuthorsDetail from '@/components/screens/authors-detail/AuthorsDetail';
import { API_URL, BOOKS_FOR_PAGE } from '@/helpers/variables';
import { IAuthorDetail } from '@/interfaces/authorDetail.interface';
import { IWidgetsSideBar } from '@/interfaces/widgets.interface';

interface IAuthorDetailPageDynamicProps extends IWidgetsSideBar {
  books: IAuthorDetail;
}

const AuthorDetailPageDynamic: NextPage<IAuthorDetailPageDynamicProps> = ({ books, todayWidget, popularBooksWidget }) => {
  return <AuthorsDetail books={books} todayWidget={todayWidget} popularBooksWidget={popularBooksWidget} />;
};
export const getServerSideProps: GetServerSideProps = async (context) => {
  const { alias } = context.query;

  const booksRes = await fetch(`${API_URL}satellite/author/info/${alias}/with_series?page=1&page_size=${BOOKS_FOR_PAGE}&sort_reversed=true`);

  // Check fetch error
  if (!booksRes.ok) {
    console.table(`Error ${booksRes.status}. Api: ${booksRes.url}`);
    return {
      notFound: true,
    };
  }

  const books = await booksRes.json();

  const [todayWidgetRes, popularBooksWidgetRes] = await Promise.all([fetch(`${API_URL}main/today/`), fetch(`${API_URL}main-page/popular_books`)]);
  const [todayWidget, popularBooksWidget] = await Promise.all([todayWidgetRes.json(), popularBooksWidgetRes.json()]);

  return {
    props: {
      books,
      todayWidget,
      popularBooksWidget,
    },
  };
};

export default AuthorDetailPageDynamic;
